export const ENTITIES_STATUSES = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;
